import { c as _c } from "react/compiler-runtime";
import { SplashScreenSdbTopic } from "@components/splash-screen/splash-screen-data";
import { FeatureTour as FeatureTourFlatUI, WelcomeDialog } from "@flat-ui";
import { useAppDispatch } from "@store/store-helper";
import { setSplashScreenStatus } from "@store/user/user-slice";
import { setFueFlags } from "@store/user/user-slice-thunk";
import { TutorialEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/** Shows a splash screen of the given topic */
export function SplashScreen(t0) {
  const $ = _c(34);
  const {
    splashScreen,
    onSplashScreenClosed
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] !== splashScreen.topic || $[1] !== trackEvent) {
    t1 = function onJumpToPage() {
      trackEvent({
        name: TutorialEvents.jumpToPage,
        props: {
          topic: splashScreen.topic
        }
      });
    };
    $[0] = splashScreen.topic;
    $[1] = trackEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onJumpToPage = t1;
  let t2;
  if ($[3] !== splashScreen.topic || $[4] !== trackEvent) {
    t2 = function onNextPage() {
      trackEvent({
        name: TutorialEvents.selectNextPage,
        props: {
          topic: splashScreen.topic
        }
      });
    };
    $[3] = splashScreen.topic;
    $[4] = trackEvent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const onNextPage = t2;
  let t3;
  if ($[6] !== splashScreen.topic || $[7] !== trackEvent) {
    t3 = function onPreviousPage() {
      trackEvent({
        name: TutorialEvents.selectPreviousPage,
        props: {
          topic: splashScreen.topic
        }
      });
    };
    $[6] = splashScreen.topic;
    $[7] = trackEvent;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onPreviousPage = t3;
  let t4;
  if ($[9] !== dispatch || $[10] !== splashScreen.topic || $[11] !== trackEvent) {
    t4 = function onSkipped() {
      trackEvent({
        name: TutorialEvents.skipTutorial,
        props: {
          topic: splashScreen.topic
        }
      });
      dispatch(setSplashScreenStatus({
        topic: splashScreen.topic,
        status: "skipped"
      }));
      dispatch(setFueFlags());
    };
    $[9] = dispatch;
    $[10] = splashScreen.topic;
    $[11] = trackEvent;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const onSkipped = t4;
  let t5;
  if ($[13] !== dispatch || $[14] !== splashScreen.topic || $[15] !== trackEvent) {
    t5 = function onFinished() {
      trackEvent({
        name: TutorialEvents.finishTutorial,
        props: {
          topic: splashScreen.topic
        }
      });
      dispatch(setSplashScreenStatus({
        topic: splashScreen.topic,
        status: "completed"
      }));
      dispatch(setFueFlags());
    };
    $[13] = dispatch;
    $[14] = splashScreen.topic;
    $[15] = trackEvent;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const onFinished = t5;
  if (splashScreen.topic === SplashScreenSdbTopic.hbToSxgMigrated) {
    let t6;
    if ($[17] !== splashScreen.topic || $[18] !== trackEvent) {
      t6 = () => {
        trackEvent({
          name: TutorialEvents.externalLinkClicked,
          props: {
            topic: splashScreen.topic
          }
        });
      };
      $[17] = splashScreen.topic;
      $[18] = trackEvent;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    let t7;
    if ($[20] !== onFinished || $[21] !== onSkipped || $[22] !== onSplashScreenClosed || $[23] !== t6) {
      t7 = <WelcomeDialog onStartExploringClicked={onFinished} onSkipButtonClicked={onSkipped} onClose={onSplashScreenClosed} onLearnMoreClicked={t6} />;
      $[20] = onFinished;
      $[21] = onSkipped;
      $[22] = onSplashScreenClosed;
      $[23] = t6;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    return t7;
  }
  let t6;
  if ($[25] !== onFinished || $[26] !== onJumpToPage || $[27] !== onNextPage || $[28] !== onPreviousPage || $[29] !== onSkipped || $[30] !== onSplashScreenClosed || $[31] !== splashScreen.content || $[32] !== splashScreen.shouldBlockTranslation) {
    t6 = <FeatureTourFlatUI pages={splashScreen.content} onNextPage={onNextPage} onPreviousPage={onPreviousPage} onSkipped={onSkipped} onFinished={onFinished} onJumpToPage={onJumpToPage} onClose={onSplashScreenClosed} shouldBlockTranslation={splashScreen.shouldBlockTranslation} />;
    $[25] = onFinished;
    $[26] = onJumpToPage;
    $[27] = onNextPage;
    $[28] = onPreviousPage;
    $[29] = onSkipped;
    $[30] = onSplashScreenClosed;
    $[31] = splashScreen.content;
    $[32] = splashScreen.shouldBlockTranslation;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  return t6;
}